import React from "react";
import { FaInstagram, FaFacebook, FaTiktok, FaYoutube, FaSpotify } from "react-icons/fa";
import "./SocialMediaIcons.css"; // Import custom CSS for styling

const SocialMediaIcons = () => {
  return (
    <div className="social-icons-container">
      <a href="https://www.instagram.com/imagomundi_official" aria-label="imago mundi – Instagram" target="_blank" rel="noopener noreferrer" className="social-icon">
        <FaInstagram />
      </a>
      <a href="https://www.facebook.com/profile.php?id=61560224145071" aria-label="imago mundi – Facebook" target="_blank" rel="noopener noreferrer" className="social-icon">
        <FaFacebook />
      </a>
      <a href="https://www.tiktok.com/@imagomundi8" aria-label="imago mundi – TikTok" target="_blank" rel="noopener noreferrer" className="social-icon">
        <FaTiktok />
      </a>
      <a href="https://www.youtube.com/@imagomundiofficial" aria-label="imago mundi – YouTube" target="_blank" rel="noopener noreferrer" className="social-icon">
        <FaYoutube />
      </a>
      <a href="https://open.spotify.com/artist/4pD0Y4NqCiTWh4IhpH2NQO" aria-label="imago mundi – Spotify" target="_blank" rel="noopener noreferrer" className="social-icon">
        <FaSpotify />
      </a>
    </div>
  );
};

export default SocialMediaIcons;